import { useSyncExternalStore } from 'react';

let isLocalReminderPending = false;
const subscribers = new Set<() => void>();

const notifySubscribers = (): void => {
	subscribers.forEach((subscriber) => subscriber());
};

export const markLocalMeetingSignalReminderPending = (): void => {
	if (isLocalReminderPending) {
		return;
	}

	isLocalReminderPending = true;
	notifySubscribers();
};

export const clearLocalMeetingSignalReminderPending = (): void => {
	if (!isLocalReminderPending) {
		return;
	}

	isLocalReminderPending = false;
	notifySubscribers();
};

const subscribeToLocalMeetingSignalReminder = (subscriber: () => void): (() => void) => {
	subscribers.add(subscriber);
	return () => {
		subscribers.delete(subscriber);
	};
};

export const useIsLocalMeetingSignalReminderPending = (): boolean =>
	useSyncExternalStore(
		subscribeToLocalMeetingSignalReminder,
		() => isLocalReminderPending,
		() => false,
	);

export const clearLocalMeetingSignalReminderStoreForTesting = (): void => {
	isLocalReminderPending = false;
	subscribers.clear();
};
